<template>
  <div class="min-h-screen bg-slate-50">
    <!-- Header Section -->
    <div class="bg-[#235D70] relative">
      <!-- <div class="absolute inset-0 bg-grid-slate-900/[0.04] bg-[size:60px_60px]"></div>
      <div class="absolute inset-0 bg-gradient-to-b from-slate-900/50 to-slate-900"></div> -->
      <div class="relative z-10 max-w-6xl ml-auto pl-6 py-3">
        <div class="flex items-center">
          <h1 class="text-2xl md:text-2xl font-bold text-white text-center mb-1 tracking-tight flex-1 w-80">
            Welcome to Mocero One Platform
          </h1>
          <!-- <p class="text-slate-400 text-base text-center max-w-2xl mx-auto font-light">
          Your unified dashboard for managing all enterprise applications
        </p> -->
          <!-- <div class="flex items-center gap-2 me-3" @click="handleLogout">
          <i class="pi pi-sign-out text-red-600 text-lg"></i>
          <span class="text-red-600 font-medium">Logout</span>
        </div> -->
          <!-- Person Icon -->
          <div class="w-14" @click="handleLogout">
            <div class="w-max  bg-white rounded-md p-1">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px"
                fill="#1f1f1f">
                <path
                  d="M224.62-160q-27.62 0-46.12-18.5Q160-197 160-224.62v-124.61h40v124.61q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h510.76q9.24 0 16.93-7.69 7.69-7.69 7.69-16.93v-510.76q0-9.24-7.69-16.93-7.69-7.69-16.93-7.69H224.62q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v124.61h-40v-124.61q0-27.62 18.5-46.12Q197-800 224.62-800h510.76q27.62 0 46.12 18.5Q800-763 800-735.38v510.76q0 27.62-18.5 46.12Q763-160 735.38-160H224.62Zm209.23-163.08-28.31-28.77L513.69-460H160v-40h353.69L405.54-608.15l28.31-28.77L590.77-480 433.85-323.08Z" />
              </svg>
            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 mt-5 pb-3">
      <!-- Content Area -->
      <div class="flex flex-col-reverse md:flex-row gap-4 mb-5 md:gap-6 mt-5 md:h-[calc(100vh-120px)]">

        <!-- Left Side Content -->
        <div class="md:w-2/5 space-y-4 md:overflow-y-auto md:pr-2 md:h-full">
          <!-- Task List Section -->
          <div class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden">
            <div class="p-3 border-b border-slate-100 flex justify-between items-center">
              <h2 class="text-base font-semibold text-slate-900">Task List</h2>
              <!-- <button v-if="isAdmin"
                class="inline-flex items-center px-2 py-1 rounded-lg bg-slate-900 text-white text-xs hover:bg-slate-800 transition-colors">
                <i class="pi pi-plus mr-1 text-[10px]"></i>
                Create
              </button> -->
            </div>
            <div class="p-3">
              <!-- {{ tasks }} -->
              <div class="text-center py-4" v-if="tasks.length == 0">
                <i class="pi pi-check-circle text-slate-300 text-xl mb-2"></i>
                <p class="text-slate-500 text-sm">No pending tasks</p>
              </div>
              <ul v-else class="divide-y divide-slate-100">
                <li v-for="(task, index) in tasks" :key="index" class="py-2">
                  <div>
                    <h3 class="text-sm font-medium text-slate-900">{{ task.TaskName }}</h3>
                    <p class="text-xs text-slate-500 mt-0.5">{{ moment(task.EndDate).format("MMM DD, YYYY - hh:mm A")
                    }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- News Section -->
          <div class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden">
            <div class="p-3 border-b border-slate-100">
              <h2 class="text-base font-semibold text-slate-900">News</h2>
            </div>
            <div class="p-3">
              <!-- {{ news }} -->
              <div class="text-center py-4" v-if="news.length == 0">
                <i class="pi pi-bell text-slate-300 text-xl mb-2"></i>
                <p class="text-slate-500 text-sm">No news available</p>
              </div>
              <ul v-else class="divide-y divide-slate-100">
                <li v-for="(item, index) in news" :key="index" class="py-2">
                  <h3 class="text-sm font-medium text-slate-900 line-clamp-1">{{ item.Title }}</h3>
                  <p class="text-xs"><span class="font-medium">{{ item.Type == 1 ? 'News' : 'Event' }}</span><span
                      class="text-slate-500 mt-0.5 ml-0.5">|
                      {{ moment(item.EventDate).format("MMM DD, YYYY - hh:mm A")
                      }}
                    </span></p>
                  <p class="text-sm text-slate-600 mt-1 line-clamp-2">{{ item.Description }}</p>
                </li>
              </ul>
            </div>
          </div>

          <!-- Social Media Posts Section -->
          <!-- <div class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden">
            <div class="p-3 border-b border-slate-100">
              <h2 class="text-base font-semibold text-slate-900">Social Media Posts</h2>
            </div>
            <div class="p-3">
              <div v-if="socialPosts.length === 0" class="text-center py-4">
                <i class="pi pi-comments text-slate-300 text-xl mb-2"></i>
                <p class="text-slate-500 text-sm">No posts available</p>
              </div>
              <div v-else class="space-y-3">
                <div v-for="(post, index) in socialPosts" :key="index" class="border border-slate-100 rounded-lg p-2">
                  <div class="flex items-center gap-2 mb-2">
                    <div class="w-6 h-6 rounded-full bg-slate-200 flex items-center justify-center">
                      <i class="pi pi-user text-slate-500 text-xs"></i>
                    </div>
                    <div>
                      <h3 class="text-sm font-medium text-slate-900">{{ post.author }}</h3>
                      <p class="text-xs text-slate-500">{{ post.date }}</p>
                    </div>
                  </div>
                  <p class="text-sm text-slate-700 mb-2 line-clamp-3">{{ post.content }}</p>
                  <div class="flex items-center gap-3 text-xs text-slate-500">
                    <button class="flex items-center gap-1 hover:text-slate-900">
                      <i class="pi pi-heart"></i>
                      <span>{{ post.likes }}</span>
                    </button>
                    <button class="flex items-center gap-1 hover:text-slate-900">
                      <i class="pi pi-comment"></i>
                      <span>{{ post.comments.length }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

        </div>

        <!-- Right Side Content - Modules -->
        <div class="md:w-3/5 md:overflow-y-auto md:h-full scrollbar-hide">
          <!-- Loading State -->
          <div v-if="loading" class="bg-white rounded-xl shadow-xl shadow-slate-200/50 p-4">
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
              <div v-for="n in 6" :key="n" class="bg-slate-50 rounded-xl p-4">
                <div class="flex items-center gap-3">
                  <div class="skeleton-box w-12 h-12 rounded-xl"></div>
                  <div class="flex-1">
                    <div class="skeleton-box w-32 h-5 mb-2"></div>
                    <div class="skeleton-box w-24 h-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Error State -->
          <div v-else-if="error" class="bg-white rounded-xl shadow-xl shadow-slate-200/50 p-6 text-center">
            <div class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-50 mb-4">
              <i class="pi pi-exclamation-circle text-red-500 text-xl"></i>
            </div>
            <h3 class="text-slate-900 text-lg font-semibold mb-2">Unable to Load Applications</h3>
            <p class="text-slate-600 mb-4">{{ error }}</p>
            <button
              class="inline-flex items-center px-4 py-2 rounded-lg bg-slate-900 text-white hover:bg-slate-800 transition-colors"
              @click="loadModules">
              <i class="pi pi-refresh mr-2"></i>
              Try Again
            </button>
          </div>

          <!-- Modules Grid -->
          <template v-else>
            <!-- Debug Info -->
            <!-- <div class="flex items-center justify-between">
              <div class="flex items-center gap-5 mb-6 mt-5 flex-wrap">
                <div class="allmoduleDetailsCard shadow-md">
                  <div class="w-8 h-8 rounded-md flex items-center justify-center bg-white">
                    <img src="../../assets/Icons/CommonIcons/total.svg" alt="" style="width:20px">
                  </div>
                  <div class="text-center">
                    <p class="text-xs text-gray-400">Total</p>
                    <p class="text-sm font-semibold">{{ modules.length }}</p>
                  </div>
                </div>
                <div class="activemoduleDetailsCard shadow-md">
                  <div class="w-8 h-8 rounded-md flex items-center justify-center bg-white">
                    <img src="../../assets/Icons/CommonIcons/active.svg" alt="" style="width:20px">
                  </div>
                  <div class="text-center">
                    <p class="text-xs text-gray-400">Active</p>
                    <p class="text-sm font-semibold">{{ accessibleModules.length }}</p>
                  </div>
                </div>
                <div class="inactivemoduleDetailsCard shadow-md">
                  <div class="w-8 h-8 rounded-md flex items-center justify-center bg-white">
                    <img src="../../assets/Icons/CommonIcons/inactive.svg" alt="" style="width:20px">
                  </div>
                  <div class="text-center">
                    <p class="text-xs text-gray-400">Inactive</p>
                    <p class="text-sm font-semibold">{{ toBePurchasedModules.length }}</p>
                  </div>
                </div>
              </div>
              <div class="flex items-center gap-2 me-3" @click="handleLogout">
                <i class="pi pi-sign-out text-red-600 text-lg"></i>
                <span class="text-red-600 font-medium">Logout</span>
              </div>
            </div> -->
            <!-- Accessible Modules -->
            <div v-if="accessibleModules.length > 0"
              class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden">
              <div class="p-3 border-b border-slate-100 flex items-center justify-between">
                <h2 class="text-medium font-semibold text-slate-900">Purchased Modules</h2>
                <span class="text-sm text-slate-500">{{ accessibleModules.length }} available</span>
              </div>
              <div class="p-4">
                <!-- {{ accessibleModules }} -->
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-3 gap-3">
                  <div v-for="module in accessibleModules" :key="module.id" class="group relative">
                    <div
                      class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
                      @click="handleModuleSelect(module)">
                      <div class="p-3">
                        <div class="flex items-center gap-3">
                          <div class="w-8 h-8 rounded-lg flex items-center justify-center"
                            :style="{ background: `linear-gradient(135deg, ${module.color}15, ${module.color}25)` }">
                            <img :src="module.icon" alt="" style="width:22px">
                          </div>
                          <div class="flex-1 min-w-0">
                            <h3 class="text-sm font-medium text-slate-900 mb-1 truncate">{{ module.name }}</h3>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="px-3 py-2 bg-slate-50 flex items-center justify-end">
                        <div
                          class="w-7 h-7 rounded-lg bg-white shadow-sm flex items-center justify-center text-slate-700 group-hover:bg-slate-900 group-hover:text-white transition-colors">
                          <i class="pi pi-arrow-right text-xs"></i>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- To Be Purchased Modules -->
            <div v-if="toBePurchasedModules.length > 0"
              class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden mt-3">
              <div class="p-3 border-b border-slate-100 flex items-center justify-between">
                <h2 class="text-medium font-semibold text-slate-900">Other Modules</h2>
                <span class="text-sm text-slate-500">{{ toBePurchasedModules.length }} available</span>
              </div>
              <div class="p-4">
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-3">
                  <div v-for="module in toBePurchasedModules" :key="module.id" class="group">
                    <div
                      class="bg-white rounded-xl shadow-lg shadow-slate-200/50 overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer">
                      <div class="p-3">
                        <div class="flex items-center gap-3">
                          <div class="w-8 h-8 rounded-lg flex items-center justify-center"
                            :style="{ background: `linear-gradient(135deg, ${module.color}15, ${module.color}25)` }">
                            <!-- <i :class="[module.icon, 'text-sm']" :style="{ color: module.color }"></i> -->
                            <img :src="module.icon" alt="" style="width:22px">
                          </div>
                          <div class="flex-1 min-w-0">
                            <h3 class="text-sm font-medium text-slate-900 mb-1 truncate">{{ module.name }}</h3>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="px-3 py-2 bg-slate-50 flex items-center justify-end">
                        <button
                          class="inline-flex items-center px-3 py-1 rounded-lg bg-slate-900 text-white text-xs hover:bg-slate-800 transition-colors">
                          <i class="pi pi-send mr-1 text-[10px]"></i>
                          Contact Sales
                        </button>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div v-if="!accessibleModules.length && !toBePurchasedModules.length"
              class="bg-white rounded-xl shadow-xl shadow-slate-200/50 p-6 text-center">
              <div class="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
                <i class="pi pi-box text-slate-400 text-2xl"></i>
              </div>
              <h3 class="text-lg font-semibold text-slate-900 mb-2">No Applications Found</h3>
              <p class="text-slate-600 mb-4">
                No applications are currently available for your organization.
              </p>
              <div class="text-sm text-slate-500">Organization ID: {{ authStore.user?.organizationId }}</div>
            </div>
          </template>
        </div>
      </div>

      <!-- Small Footer -->
      <div class="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200  py-4 z-40 shadow-lg">
        <div class="max-w-7xl mx-auto px-4">
          <div class="flex flex-wrap items-center justify-between gap-4 text-xs text-slate-500">
            <!-- Product Updates -->
            <div class="flex items-center gap-4">
              <span class="font-medium text-slate-600">Latest:</span>
              <div v-if="productUpdates.length > 0" class="flex items-center gap-2">
                <div class="pulse-dot mr-1"></div>
                <span :class="{ 'blink-update': productUpdates[0].isNew }">{{ productUpdates[0].title }}</span>
                <span class="text-slate-400">({{ productUpdates[0].date }})</span>
                <span v-if="productUpdates[0].isNew"
                  class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800 ml-1">New</span>
                <span v-if="productUpdates.length > 1" ref="updatesMenuButton"
                  class="text-blue-600 cursor-pointer hover:text-blue-800 ml-2" @click="toggleUpdatesMenu">
                  +{{ productUpdates.length - 1 }} more updates
                </span>
              </div>
              <span v-else class="text-slate-400">No updates</span>

              <!-- Product Updates Menu -->
              <Menu ref="updatesMenu" :model="updatesMenuItems" :popup="true" class="text-xs" />
            </div>

            <!-- Right side - Help and Policy -->
            <div class="flex items-center gap-6">
              <!-- Help Documents -->
              <div class="flex items-center gap-2">
                <span class="font-medium text-slate-600">Help:</span>
                <button v-if="helpDocs.length > 0" ref="helpMenuButton"
                  class="flex items-center gap-1 cursor-pointer hover:text-slate-700" @click="toggleHelpMenu">
                  <i class="pi pi-question-circle text-green-500"></i>
                  <span>Documentation ({{ helpDocs.length }})</span>
                </button>
                <span v-else class="text-slate-400">No docs</span>

                <!-- Help Documents Menu -->
                <Menu ref="helpMenu" :model="helpMenuItems" :popup="true" class="text-xs" />
              </div>

              <!-- Policy/SOP -->
              <div class="flex items-center gap-2">
                <span class="font-medium text-slate-600">Policy:</span>
                <button v-if="policies.length > 0" ref="policyMenuButton"
                  class="flex items-center gap-1 cursor-pointer hover:text-slate-700" @click="togglePolicyMenu">
                  <i class="pi pi-file text-red-500"></i>
                  <span>SOP ({{ policies.length }})</span>
                </button>
                <span v-else class="text-slate-400">No policies</span>

                <!-- Policy Menu -->
                <Menu ref="policyMenu" :model="policyMenuItems" :popup="true" class="text-xs" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <MOPProfileSidebar ref="profileSidebar" /> -->

</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '../../stores/auth'
import { moduleService, type Module } from '../../services/moduleService'
import { useToast } from 'primevue/usetoast'
import Menu from 'primevue/menu'
import moment from 'moment'



const router = useRouter()
const authStore = useAuthStore()
const toast = useToast()

const loading = ref<boolean>(false)
const error = ref<string | null>(null)
const modules = ref<Module[]>([])

// Footer dropdown states
const showAllUpdates = ref<boolean>(false)
const showHelpDocs = ref<boolean>(false)

// PrimeVue Menu refs
const updatesMenu = ref()
const helpMenu = ref()
const policyMenu = ref()
const updatesMenuButton = ref()
const helpMenuButton = ref()
const policyMenuButton = ref()

// User role check
const isAdmin = computed(() => {
  return authStore.user?.roleId === 1
})

// Sample data for new sections
const tasks: any = ref([])
const news: any = ref([])

const policies = ref([
  { title: 'Data Security Policy', updatedDate: 'May 30, 2025' },
  { title: 'Remote Work Guidelines', updatedDate: 'Jun 2, 2025' },
  { title: 'Compliance Procedures', updatedDate: 'May 15, 2025' }
])

const socialPosts = ref([
  {
    author: 'Marketing Team',
    date: 'Jun 7, 2025',
    content: 'We\'re excited to announce our participation in the upcoming Tech Summit 2025!',
    likes: 24,
    comments: [
      { author: 'John Doe', text: 'Looking forward to it!' }
    ]
  },
  {
    author: 'HR Department',
    date: 'Jun 5, 2025',
    content: 'Congratulations to our Employee of the Month, Jane Smith!',
    likes: 42,
    comments: [
      { author: 'Alice Johnson', text: 'Well deserved!' },
      { author: 'Bob Williams', text: 'Congratulations Jane!' }
    ]
  }
])

const productUpdates = ref([
  {
    title: 'Version 2.5 Released',
    date: 'Jun 6, 2025',
    description: 'This update includes performance improvements and bug fixes.',
    isNew: true
  },
  {
    title: 'New Module: Advanced Analytics',
    date: 'May 28, 2025',
    description: 'Explore our new data visualization and reporting capabilities.',
    isNew: false
  }
])

const helpDocs = ref([
  { title: 'Getting Started Guide', category: 'Onboarding' },
  { title: 'User Management', category: 'Administration' },
  { title: 'Reporting Features', category: 'Analytics' }
])

// Create a ref for development mode check
const isDev = computed(() => import.meta.env.DEV)

// Computed properties for module lists
const accessibleModules = computed(() =>
  modules.value.filter(module => module.isAccessible)
)

const toBePurchasedModules = computed(() =>
  modules.value.filter(module => !module.isAccessible)
)

// Menu items for PrimeVue Menu
const updatesMenuItems = computed(() =>
  productUpdates.value.map(update => ({
    label: update.title,
    icon: 'pi pi-tag',
    command: () => {
      // Handle update click if needed
      console.log('Update clicked:', update.title)
    }
  }))
)

const helpMenuItems = computed(() =>
  helpDocs.value.map(doc => ({
    label: doc.title,
    icon: 'pi pi-file-pdf',
    command: () => {
      // Handle help doc click if needed
      console.log('Help doc clicked:', doc.title)
    }
  }))
)

const policyMenuItems = computed(() =>
  policies.value.map(policy => ({
    label: policy.title,
    icon: 'pi pi-file-pdf',
    command: () => {
      // Handle policy click if needed
      console.log('Policy clicked:', policy.title)
    }
  }))
)

// Menu toggle functions
function toggleUpdatesMenu(event: Event) {
  updatesMenu.value.toggle(event)
}

function toggleHelpMenu(event: Event) {
  helpMenu.value.toggle(event)
}

function togglePolicyMenu(event: Event) {
  policyMenu.value.toggle(event)
}

// Load modules from API
async function loadModules() {
  try {
    error.value = null
    loading.value = true

    const organizationId = authStore.user?.organizationId
    console.log('Loading modules with organizationId:', organizationId)

    if (!organizationId) {
      throw new Error('Organization ID not found. Please try logging in again.')
    }

    modules.value = await moduleService.getUserModules(organizationId)
    console.log('Loaded modules:', modules.value)

  } catch (err) {
    console.error('Error loading modules:', err)
    error.value = err instanceof Error ? err.message : 'Failed to load modules'
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: error.value,
      life: 3000
    })
  } finally {
    loading.value = false
  }
}

// Handle module selection with unified navigation
async function handleModuleSelect(module: Module) {
  try {
    if (!module.isAccessible) return

    loading.value = true
    console.log('Selected module:', module)

    const roleId = authStore.user?.roleId
    if (!roleId) throw new Error('Role ID not found')

    // Validate moduleId before making API calls
    if (!module.id || typeof module.id !== 'number') {
      throw new Error('Invalid module ID')
    }

    console.log('Fetching module data with roleId:', roleId, 'moduleId:', module.id)
    const moduleData = {
      id: module.id,
      name: module.name,
      rights: [],
      menu: { menus: [], subMenus: [] } // Initialize with empty menu structure
    }

    authStore.setActiveModule(moduleData)
    // Handle different module types
    if (module.type === 'moceroui') {
      // Handle MoceroUI modules
      await handleMoceroUIModule(module)
    } else {
      // Handle MOPUI modules (existing logic)
      await handleMOPUIModule(module, roleId)
    }


    toast.add({
      severity: 'success',
      summary: 'Success',
      detail: `Switched to ${module.name} module`,
      life: 3000
    })
  } catch (error) {
    console.error('Error switching module:', error)
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: error instanceof Error ? error.message : 'Failed to switch module',
      life: 3000
    })
  } finally {
    loading.value = false
  }
}

// Handle MoceroUI module navigation
async function handleMoceroUIModule(module: Module) {
  try {
    console.log('Handling MoceroUI module:', module.name)

    // Prepare session data for MoceroUI
    await moduleService.prepareSessionForMoceroUI(module)

    // Navigate to MoceroUI
    moduleService.navigateToMoceroUI(module)

  } catch (error) {
    console.error('Error handling MoceroUI module:', error)
    throw new Error(`Failed to navigate to ${module.name} module`)
  }
}

// Handle MOPUI module navigation
async function handleMOPUIModule(module: Module, roleId: number) {
  try {
    console.log('Handling MOPUI module:', module.name)

    // Fetch rights for MOPUI modules
    const [rights] = await Promise.all([
      moduleService.getModuleRights(roleId, module.id)
    ])

    console.log('Fetched module rights:', rights)

    // Special handling for specific modules
    if (module.id === 10) {
      // Navigate to TaskManagement router without query params
      await router.push({ path: '/Task' })
    }
    // else if (module.id === 9) {
    //   await router.push({ path: '/accounts' })
    // }
    else {
      // Standard MOPUI module navigation
      await router.push({
        path: '/MOPLayout',
        query: { moduleId: module.id.toString() }
      })
    }

  } catch (error) {
    console.error('Error handling MOPUI module:', error)
    throw new Error(`Failed to navigate to ${module.name} module`)
  }
}

const handleLogout = async () => {
  try {
    // Remove token from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('RolesData');
    localStorage.removeItem('UsersData');
    // Clear auth store
    authStore.clearAuth();
    // Redirect to login
    await router.push('/');
  } catch (error) {
    console.log(error);

  }
};


const loadNews = async () => {
  news.value = [];
  try {

    let response = await moduleService.loadNews();
    news.value = response['result']
  }
  catch {
    console.error('Error fetching news:', error);
  }
}


const loadTasks = async () => {
  tasks.value = [];
  try {

    let response = await moduleService.loadTasks();
    tasks.value = response['result']
  }
  catch {
    console.error('Error fetching news:', error);
  }
}

onMounted(async () => {
  console.log('DashboardView mounted, auth state:', {
    user: authStore.user,
    organizationId: authStore.user?.organizationId
  })
  await loadModules()
  await loadNews()
  await loadTasks()
})
</script>

<style scoped>
.bg-grid-slate-900\/\[0\.04\] {
  mask-image: linear-gradient(to bottom, transparent, black);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32' width='32' height='32' fill='none' stroke='rgb(148 163 184 / 0.1)'%3E%3Cpath d='M0 .5H31.5V32'/%3E%3C/svg%3E");
}

.skeleton-box {
  position: relative;
  overflow: hidden;
  background-color: #f1f5f9;
  border-radius: 0.75rem;
}

.skeleton-box::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-100%);
  background-image: linear-gradient(90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0));
  animation: shimmer 2s infinite;
  content: '';
}

@keyframes shimmer {
  100% {
    transform: translateX(100%);
  }
}

/* Text truncation */
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Blinking animation for updates */
.blink-update {
  animation: highlight-pulse 2s infinite;
}

@keyframes highlight-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.2);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(59, 130, 246, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
  }
}

/* Pulse dot for updates section */
.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #3b82f6;
  position: relative;
}

.pulse-dot::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #3b82f6;
  animation: pulse-ring 2s infinite;
  transform: scale(1);
  opacity: 1;
}

@keyframes pulse-ring {
  0% {
    transform: scale(0.8);
    opacity: 0.8;
  }

  70% {
    transform: scale(2);
    opacity: 0;
  }

  100% {
    transform: scale(0.8);
    opacity: 0;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {

  .md\:col-span-1,
  .md\:col-span-2 {
    grid-column: span 1 / span 1;
  }

  .md\:h-\[calc\(100vh-150px\)\] {
    height: auto;
  }

  .md\:overflow-y-auto {
    overflow-y: visible;
  }

  .md\:h-full {
    height: auto;
  }
}

/* Custom scrollbar for better UX */
.md\:overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.md\:overflow-y-auto::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.md\:overflow-y-auto::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.md\:overflow-y-auto::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.allmoduleDetailsCard {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 15px;
  background-color: #e9f8ea;
  border-radius: 5px;
}

.activemoduleDetailsCard {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 15px;
  background-color: #F1F3FE;
  border-radius: 5px;
}

.inactivemoduleDetailsCard {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 8px 15px;
  background-color: #FEF3F1;
  border-radius: 5px;
}

/* Hide scrollbar but keep scrolling */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari */
}
</style>
